// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {Fragment, ReactNode} from 'react';
import {Image} from '@shopify/hydrogen';
import {Button} from './Button.client';
import clsx from 'clsx';
import {X} from 'react-feather';

interface DefaultModalProp {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  isOpen: boolean;
  hasConfirmButton?: boolean;
  hasCloseButton?: boolean;
  confirmButtonText?: string;
  onConfirm?: () => void;
  onClose: () => void;
  onConfirmTo?: string;
  className?: string;
}

export function DefaultModal({
  title,
  subtitle,
  children,
  isOpen,
  hasConfirmButton = false,
  hasCloseButton = false,
  confirmButtonText = 'Confirm',
  onConfirm,
  onConfirmTo,
  onClose,
  className,
}: DefaultModalProp) {
  const t = title?.split(' ').map((e, i) =>
    i > 1 ? (
      <span key={e} className="font-serif italic">
        {e}
      </span>
    ) : (
      <>{e} </>
    ),
  );
  return (
    <Transition as={Fragment} show={isOpen} appear>
      <Dialog
        as="div"
        className="relative z-[10000] text-acai-900"
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className={clsx('p-4 !pt-24 text-center', className)}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="h-full min-h-full transform overflow-hidden bg-foam-100 px-8 py-8 text-left align-middle shadow-xl transition-all md:h-fit md:min-h-fit md:rounded-2xl md:px-16 md:py-10">
                {(title || subtitle) && (
                  <div className="mb-7 flex items-center justify-center space-x-4">
                    <div className="text-center text-3xl">
                      {t ?? 'Default Modal'}
                      {subtitle && (
                        <div className="mx-auto w-2/3 pt-2 font-sans text-sm">
                          {subtitle}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="mb-7 flex justify-center space-x-2.5">
                  <div className="flex flex-col space-y-2.5">{children}</div>
                  <div className="absolute right-2 top-2">
                    <button
                      className="rounded-full border border-acai-900 p-2"
                      onClick={onClose}
                    >
                      <X width={8} height={8} />
                    </button>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-between gap-2">
                  {hasConfirmButton &&
                    (onConfirmTo ? (
                      <Button url={onConfirmTo}>{confirmButtonText}</Button>
                    ) : (
                      <Button handleClick={onConfirm}>
                        {confirmButtonText}
                      </Button>
                    ))}
                  {hasCloseButton && (
                    <button className="underline" onClick={onClose}>
                      Close window
                    </button>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
